<div class="detail">
  <div class="detail-top">
    <div class="detail-number">#{{ ticket.ticketNumber }}</div>
    <span
      class="detail-status"
      [ngClass]="'status-' + (ticket.ticketStatus || 'unknown').toLowerCase()"
    >
      {{ ticket.ticketStatus }}
    </span>
  </div>

  <h3 class="detail-event">{{ ticket.event?.name }}</h3>

  <dl class="detail-facts">
    <dt>Date</dt>
    <dd>{{ (ticket.event?.date | date: 'fullDate') || 'To be announced' }}</dd>

    <dt>Venue</dt>
    <dd>{{ ticket.event?.location?.description || 'Online' }}</dd>

    <dt>Ticket type</dt>
    <dd>{{ ticket.ticketType?.name || '—' }}</dd>

    <dt>Order</dt>
    <dd>
      <a [routerLink]="['/orders', ticket.orderNumber]" (click)="close()">
        {{ ticket.orderNumber }}
      </a>
    </dd>

    <!--
      Only when the ticket actually has a wallet — an event can run wallets while this ticket has
      none, because wallets are created at issue and this ticket predates the flag (QA finding
      NEW-6). Showing "0.00" there would claim a wallet that does not exist.
    -->
    <ng-container *ngIf="data.hasWallet">
      <dt>Wallet</dt>
      <dd class="detail-wallet">
        <ng-container *ngIf="data.balances.length; else emptyWallet">
          <span *ngFor="let leg of data.balances" class="detail-wallet-leg">
            {{ leg.balance }} {{ leg.currencyCode }}
          </span>
        </ng-container>
        <ng-template #emptyWallet>Nothing loaded yet</ng-template>
      </dd>
    </ng-container>
  </dl>

  <div class="detail-actions">
    <a nz-button nzType="default" [href]="data.downloadUrl" download>
      <i nz-icon nzType="download" aria-hidden="true"></i> Download
    </a>
    <a
      *ngIf="ticket.event?.walletsEnabled && data.hasWallet"
      nz-button
      nzType="primary"
      [routerLink]="['/wallet-top-up']"
      [queryParams]="{ ticketUid: ticket.uid, ticketNumber: ticket.ticketNumber }"
      (click)="close()"
    >
      <i nz-icon nzType="wallet" aria-hidden="true"></i> Top Up Wallet
    </a>
  </div>
</div>
